import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetAvailableTagsResponse } from "./GetAvailableTagsResponse";

const ENDPOINT = "/device/available_tags";

export class GetAvailableTagsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetAvailableTagsResponse> {
        var res = await this.executeCommand();
        return new GetAvailableTagsResponse(res);
    }
}
